// extracted by mini-css-extract-plugin
module.exports = {"bm-section":"bm-section","team-form-section":"team-form-section","title":"title","form-team-wrapper":"form-team-wrapper"};